<template>
  <div class="modal fade" id="caImageModal" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <img id="caImageDisplay" :alt="file.name" />
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center chat-attachment m-1 p-1 pointer" dir="ltr"
    @click="imageFileExtensions.includes(file.extension) ? openFile() : downloadFile()"
    :title="file.fileName + '.' + file.extension">
    <div class="d-flex flex-column ms-1 me-1 lh-sm w-100 text-truncate">
      <div class="align-self-start">{{ file.fileName }}</div>
      <div class="d-flex justify-content-between">
        <div>{{ '.' + file.extension }}</div>
        <div>{{ $filters.formatBytes(file.length) }}</div>
      </div>
    </div>
    <fa-icon :icon="imageFileExtensions.includes(file.extension) ? 'fas fa-image' : 'fas fa-file-download'" size="2x"
      class=" m-1" />
  </div>
</template>

<script>
import BaseService from '../../../services/Base-service';

export default {
  props: ['file'],
  data() {
    return {
      imageFileExtensions: 'apng,png,avif,gif,jpg,jpeg,jfif,pjpeg,pjp,svg,webp',
    }
  },
  methods: {
    openFile() {
      document.getElementById('caImageDisplay').src = this.$store.getters.get_api_url + 'File/ShowFileByGuid/' + this.file.guid;

      var myModal = new bootstrap.Modal(document.getElementById('caImageModal'));
      myModal.show();
    },
    downloadFile() {
      window.open(
        BaseService.getUnAuthorized('File/DownloadFile/' + this.file.guid),
        "_blank"
      );
    },
  }
}
</script>